import { forwardRef } from 'react';
import ImmobiliPrintItem from './ImmobiliPrintItem';

const ImmobiliPrintView = forwardRef(({ building, includePhotos = true }, ref) => {
    return (
        <div ref={ref} className="print-container">
            <style>{`
                @media print {
                    body {
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }

                    .print-item {
                        page-break-inside: avoid;
                        break-inside: avoid;
                    }

                    .print-header {
                        page-break-after: avoid;
                    }
                }
            `}</style>
            <div className="print-header">
                <h1 className="text-2xl font-bold text-center border-t-2 border-b-2 border-orange-500 py-2">
                    Immobili
                </h1>
            </div>
            <div className="print-items-container">
                    <ImmobiliPrintItem building={building} includePhotos={includePhotos} key={building.idAnnuncio} />
            </div>
        </div>
    );
});

ImmobiliPrintView.displayName = 'ImmobiliPrintView';

export default ImmobiliPrintView;